import { css } from '@emotion/react';

export default $ => css`
  li.dropdown ul {
    display: none;
  }

  .fa.fa-caret-right {
    transition: transform 150ms ease-in-out;
  }

  .is-sticky {
    position: fixed;
    top: 81px;
    z-index: 999;
    right: 0;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    padding-left: 30px;
    padding-right: 30px;
  }

  .form-component.sidepanel-form {
    > .card {
      border-width: 0;
    }

    &.marginless {
      > .card > .card-body {
        margin: 0;
        padding: 0;
      }
    }
  }
`;
